export default "__VITE_ASSET__6400ba0a__"